import { ThemeType } from '@app/api/models/Theme';
import styled from 'lib/styled';
import React from 'react';
import { FC } from 'react';
import { colors } from '../../Shared/Style/colors';
import { ReactComponent as Icon } from '../sofa.svg';

const ThemedSofa = styled(Icon)(({ theme }: { theme: ThemeType }) => {
    return {
        height: '24px',
        width: '24px',
        '& path': {
            stroke: theme?.colors?.icons || colors.icons,
            strokeWidth: '3px',
        },
        '& line': {
            stroke: theme?.colors?.icons || colors.icons,
        },
    };
});
const Sofa: FC = ({ ...rest }) => {
    return <ThemedSofa {...rest} />;
};

export default Sofa;
